import { Footer } from "@/components/ui/modem-animated-footer";
import {
  Twitter,
  Linkedin,
  Github,
  Mail,
} from "lucide-react";
import Image from "@/components/ui/image";
import ayraLogoLight from "@/assets/ayra-logo-light.png";
import ayraLogoDark from "@/assets/ayra-logo-dark.png";

export default function FooterDemo() {
  const socialLinks = [
    {
      icon: <Twitter className="w-4 h-4" />,
      href: "https://twitter.com",
      label: "Twitter",
    },
    {
      icon: <Linkedin className="w-4 h-4" />,
      href: "https://linkedin.com",
      label: "LinkedIn",
    },
    {
      icon: <Github className="w-4 h-4" />,
      href: "https://github.com",
      label: "GitHub",
    },
    {
      icon: <Mail className="w-4 h-4" />,
      href: "mailto:contact@ayra.ai",
      label: "Email",
    },
  ];

  const footerLinkGroups = [
    {
      label: "Product",
      links: [
        { label: "AI Assistant", href: "/" },
        { label: "Automation", href: "/" },
        { label: "Integrations", href: "/" },
        { label: "API", href: "/" },
        { label: "Pricing", href: "/" },
      ],
    },
    {
      label: "Solutions",
      links: [
        { label: "For Businesses", href: "/businesses" },
        { label: "For Agencies", href: "/agency-partners" },
        { label: "Use Cases", href: "/" },
        { label: "Case Studies", href: "/" },
      ],
    },
    {
      label: "Resources",
      links: [
        { label: "Blog", href: "/blog" },
        { label: "Documentation", href: "https://docs.ayra.cx/docs/get-started/welcome" },
        { label: "Guides", href: "/" },
        { label: "Support", href: "/contact" },
      ],
    },
    {
      label: "Company",
      links: [
        { label: "About", href: "/about" },
        { label: "Contact", href: "/contact" },
        { label: "Privacy Policy", href: "/" },
        { label: "Terms of Service", href: "/" },
      ],
    },
  ];

  return (
    <Footer
      brandName="AYRA AI"
      brandDescription="AI-powered assistant designed to streamline your digital workflows and handle mundane tasks, so you can focus on what truly matters."
      socialLinks={socialLinks}
      footerLinkGroups={footerLinkGroups}
      brandIcon={
        <Image
          src={ayraLogoLight}
          alt="AYRA AI Logo"
          className="w-8 h-8 object-contain"
        />
      }
      bottomLogo={
        <Image
          src={ayraLogoDark}
          alt="AYRA AI Logo"
          className="w-8 sm:w-10 md:w-14 h-8 sm:h-10 md:h-14 object-contain drop-shadow-lg"
        />
      }
    />
  );
}
